module.exports = __webpack_public_path__ + "01_very_short_brown.20f6744d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_very_short_brown.png
// module id = mGc0
// module chunks = 0